import { Button, Layout, Menu } from "antd";
import { useState } from "react";
import styled from "styled-components";
import Icon from "./common/Icon";
import { LogoutOutlined } from "@ant-design/icons";

const { Sider } = Layout;

export enum TABS {
  LEAD_MANAGEMENT = "LEAD_MANAGEMENT",
  INCENTIVE_MANAGEMENT = "INCENTIVE_MANAGEMENT",
  MY_PROFILE = "MY_PROFILE",
}

type SidebarProps = {
  selectedTab: TABS;
  isLogoutLoading: boolean;
  onMenuSelect: (tab: TABS) => void;
  handleLogout: () => void;
};

const Sidebar = ({
  selectedTab,
  isLogoutLoading,
  onMenuSelect,
  handleLogout,
}: SidebarProps) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleMenuSelect = ({ key }: { key: string }) => {
    onMenuSelect(key as TABS);
  };

  const toggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      trigger={null}
      theme="light"
      color="white"
      width={320}
    >
      <SidebarContainer>
        <IconWrapper onClick={toggleCollapse}>
          <Icon name={collapsed ? "nav_open" : "nav_close"} width={27} />
        </IconWrapper>
        {!collapsed && <span style={{ color: "black" }}>Navigation</span>}
      </SidebarContainer>
      <StyledMenu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["1"]}
        selectedKeys={[selectedTab]}
        onSelect={handleMenuSelect}
      >
        <Menu.Item
          key={TABS.LEAD_MANAGEMENT}
          icon={
            <Icon
              name={
                selectedTab === TABS.LEAD_MANAGEMENT
                  ? "lead_management_primary"
                  : "lead_management"
              }
              width={27}
              hideMargin
            />
          }
        >
          Lead Management
        </Menu.Item>
        <Menu.Item
          key={TABS.INCENTIVE_MANAGEMENT}
          icon={
            <Icon
              name={
                selectedTab === TABS.INCENTIVE_MANAGEMENT
                  ? "incentive_primary"
                  : "incentive"
              }
              width={27}
              hideMargin
            />
          }
        >
          Incentive Management
        </Menu.Item>
        <Menu.Item
          key={TABS.MY_PROFILE}
          icon={
            <Icon
              name={
                selectedTab === TABS.MY_PROFILE
                  ? "user_admin_primary"
                  : "user_admin"
              }
              width={27}
              hideMargin
            />
          }
        >
          My Profile
        </Menu.Item>
      </StyledMenu>
      <LogoutContainer>
        <Button
          icon={<LogoutOutlined rotate={180} />}
          color="primary"
          variant="outlined"
          onClick={handleLogout}
          loading={isLogoutLoading}
        >
          {collapsed ? "" : "Logout"}
        </Button>
      </LogoutContainer>
    </Sider>
  );
};

export default Sidebar;

const SidebarContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1rem 1rem 0;
  color: white;
  font-size: 18px;
  font-weight: 600;
`;

const IconWrapper = styled.span`
  margin-left: 0.8rem;
  margin-right: 0.3rem;
  font-size: 20px;
`;

const StyledMenu = styled(Menu)`
  .ant-menu-inline-collapsed {
    padding: 4rem;
  }
  .ant-menu-item {
    padding-left: 1.1rem !important;
  }
  .ant-menu-item-selected {
    color: blue;
    font-weight: 700;
  }
`;

const LogoutContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
